module.exports = "<div class=\"col-md-12 py-4\">\n  <div #editorContainer class=\"jsoneditor-container\"></div>\n  <button class=\"button btn submit rounded-md\" (click)=\"submit()\">Submit</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/json-editor-modal/json-editor-modal.component.html
// module id = ./src/app/json-editor-modal/json-editor-modal.component.html
// module chunks = main